import Page from "./Page";
import './styles.css'


export default Page